import ApiAuth from './ApiAuth'

export const Users = {

    users(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`/users?sort_by=${data.orderBy}.${data.orderDirection}`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            })
        });
    },
    createUser(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().post('/user', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response);
            })
        });
    },
    deleteUser(context, id) {
        return new Promise((resolve, reject) => {
            ApiAuth().delete(`/user/${id}`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response);
            })
        })
    },
    getUser(context, id) {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`/user/${id}`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response);
            })
        })
    },
    editUser(context, data){
        return new Promise((resolve, reject) => {
            ApiAuth().put(`/user/${data.id}`, data.data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response);
            })
        })
    },
    me(context) {
        return new Promise((resolve, reject) => {
            ApiAuth().get('/user/me').then(response => {
                context.commit('setLoggedUser', response.data);
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    editLoggedUser(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().put('/user', data).then(response => {
                context.commit('setLoggedUser', response.data);
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    changeStatus(context, id) {
        return new Promise((resolve, reject) => {
            ApiAuth().put(`/user/${id}/change`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        })
    }
};
